export default ['locations.familysearch.org']
